import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { DFHero } from '../components/dermal-fillers/DFHero';
import { DFArt } from '../components/dermal-fillers/DFArt';
import { DFWhatAre } from '../components/dermal-fillers/DFWhatAre';
import { DFProducts } from '../components/dermal-fillers/DFProducts';
import { DFResults } from '../components/dermal-fillers/DFResults';
import { DFAdministered } from '../components/dermal-fillers/DFAdministered';
import { DFFAQ } from '../components/dermal-fillers/DFFAQ';
import { DFWhyChoose } from '../components/dermal-fillers/DFWhyChoose';
import { DFCTA } from '../components/dermal-fillers/DFCTA';
export function DermalFillersPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2497">
      <Navigation data-id="element-2498" />
      <main data-id="element-2499">
        <DFHero data-id="element-2500" />
        <DFArt data-id="element-2501" />
        <DFWhatAre data-id="element-2502" />
        <DFProducts data-id="element-2503" />
        <DFResults data-id="element-2504" />
        <DFAdministered data-id="element-2505" />
        <DFFAQ data-id="element-2506" />
        <DFWhyChoose data-id="element-2507" />
        <DFCTA data-id="element-2508" />
      </main>
      <Footer data-id="element-2509" />
    </div>;
}